import { TripProviderTypes } from '../../lib/types/models/trip-provider/trip-provider'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripProvider(data: UpdateInput<TripProviderTypes.Input>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.tripProviders.update.url, { id })).patch(rest)
}
